import { object, string } from 'yup';

import { StoreProductType } from 'v2/constants';
import { StoreProductModel } from 'v2/types/StoreModel';

export type StoreProductForm = Omit<StoreProductModel, 'id'>;

export const validationSchema = object().shape({
  iconId: string().trim().required(),
});

export const initialValues: StoreProductForm = {
  shortDescription: '',
  fullDescription: '',
  name: '',
  value: '',
  price: 0,
  lockDays: 0,
  count: 0,
  type: StoreProductType.BALANCE,
  iconId: '',
  casinoName: '',
  casinoLink: '',
  promocodes: [],
};
